import React from 'react';
import { Facebook, Instagram, Youtube } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-300 py-12 border-t border-gray-800" data-id="element-145">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-146">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-147">
          <div className="col-span-1 md:col-span-1" data-id="element-148">
            <div className="flex items-center gap-3 mb-4" data-id="element-149">
              <img src="https://cdn.magicpatterns.com/uploads/owR9nW8R3mfWdbuvzVE1p4/Logo_don_gian_O.png" alt="Lux Hair Logo" className="h-12 w-auto object-contain" data-id="element-150" />
              <div className="flex flex-col" data-id="element-151">
                <span className="text-xl font-bold leading-none text-white" data-id="element-152">
                  LUX HAIR
                </span>
                <span className="text-[10px] tracking-widest uppercase text-gray-400" data-id="element-153">
                  Vietnam Factory
                </span>
              </div>
            </div>
            <p className="text-sm text-gray-400 mb-6" data-id="element-154">
              Premium Vietnamese Hair Factory Supplying Wholesalers Worldwide —
              Built on Quality, Consistency, and Trust.
            </p>
            <div className="flex gap-4" data-id="element-155">
              <a href="https://www.facebook.com/profile.php?id=61578577686051&mibextid=LQQJ4d" target="_blank" rel="noopener noreferrer" className="hover:text-[#d4af37] transition-colors" aria-label="Facebook" data-id="element-156">
                <Facebook className="w-5 h-5" data-id="element-157" />
              </a>
              <a href="https://www.instagram.com/lux_hair_vn.factory/" target="_blank" rel="noopener noreferrer" className="hover:text-[#d4af37] transition-colors" aria-label="Instagram" data-id="element-158">
                <Instagram className="w-5 h-5" data-id="element-159" />
              </a>
              <a href="https://www.youtube.com/@Luxhairvietnamfactory" target="_blank" rel="noopener noreferrer" className="hover:text-[#d4af37] transition-colors" aria-label="YouTube" data-id="element-160">
                <Youtube className="w-5 h-5" data-id="element-161" />
              </a>
              <a href="https://www.tiktok.com/@luxhairvnofficial" target="_blank" rel="noopener noreferrer" className="hover:text-[#d4af37] transition-colors" aria-label="TikTok" data-id="element-162">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-163">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-164" />
                </svg>
              </a>
            </div>
          </div>

          <div data-id="element-165">
            <h4 className="text-white font-semibold mb-4" data-id="element-166">
              Lux Hair VN – Define Beauty
            </h4>
            <ul className="space-y-2 text-sm" data-id="element-167">
              <li data-id="element-168">
                <a href="#factory" className="hover:text-[#d4af37] transition-colors" data-id="element-169">
                  About Factory
                </a>
              </li>
              <li data-id="element-170">
                <a href="#collection" className="hover:text-[#d4af37] transition-colors" data-id="element-171">
                  Hair Collections
                </a>
              </li>
              <li data-id="element-172">
                <a href="#pricing" className="hover:text-[#d4af37] transition-colors" data-id="element-173">
                  Wholesale Pricing
                </a>
              </li>
              <li data-id="element-174">
                <a href="#contact" className="hover:text-[#d4af37] transition-colors" data-id="element-175">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-176">
            <h4 className="text-white font-semibold mb-4" data-id="element-177">Products</h4>
            <ul className="space-y-2 text-sm" data-id="element-178">
              <li data-id="element-179">
                <a href="#" className="hover:text-[#d4af37] transition-colors" data-id="element-180">
                  Bone Straight Hair
                </a>
              </li>
              <li data-id="element-181">
                <a href="#" className="hover:text-[#d4af37] transition-colors" data-id="element-182">
                  Raw Bulk Hair
                </a>
              </li>
              <li data-id="element-183">
                <a href="#" className="hover:text-[#d4af37] transition-colors" data-id="element-184">
                  Wavy & Curly
                </a>
              </li>
              <li data-id="element-185">
                <a href="#" className="hover:text-[#d4af37] transition-colors" data-id="element-186">
                  Closures & Frontals
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-187">
            <h4 className="text-white font-semibold mb-4" data-id="element-188">Legal</h4>
            <ul className="space-y-2 text-sm" data-id="element-189">
              <li data-id="element-190">
                <a href="#" className="hover:text-[#d4af37] transition-colors" data-id="element-191">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-192">
                <a href="#" className="hover:text-[#d4af37] transition-colors" data-id="element-193">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-194">
                <a href="#" className="hover:text-[#d4af37] transition-colors" data-id="element-195">
                  Shipping Policy
                </a>
              </li>
              <li data-id="element-196">
                <a href="#" className="hover:text-[#d4af37] transition-colors" data-id="element-197">
                  Return Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-gray-500" data-id="element-198">
          <p data-id="element-199">
            &copy; {new Date().getFullYear()} Lux Hair Vietnam Factory. All
            rights reserved.
          </p>
          <p data-id="element-200">Designed for Wholesale Excellence.</p>
        </div>
      </div>
    </footer>;
}